var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.25 10C26.25 7.92894 24.5711 6.25 22.5 6.25H12.5C10.4289 6.25 8.75 7.92894 8.75 10V25C8.75 27.0711 10.4289 28.75 12.5 28.75H22.5C24.5711 28.75 26.25 27.0711 26.25 25V10ZM23.75 10C23.75 9.30965 23.1904 8.75 22.5 8.75H12.5C11.8096 8.75 11.25 9.30965 11.25 10V25C11.25 25.6904 11.8096 26.25 12.5 26.25H22.5C23.1904 26.25 23.75 25.6904 23.75 25V10Z",
    fill: "#0F0F0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.75H20C20.6904 3.75 21.25 3.19035 21.25 2.5C21.25 1.80965 20.6904 1.25 20 1.25H7.5C5.42894 1.25 3.75 2.92894 3.75 5V22.5C3.75 23.1904 4.30965 23.75 5 23.75C5.69035 23.75 6.25 23.1904 6.25 22.5V5C6.25 4.30965 6.80965 3.75 7.5 3.75Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_Icon.37284a7d173206b483f3f2ec3d0d19f4.svg";
export { ForwardRef as ReactComponent };